module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAABFUlEQVQ4T63VsRGCMBQA0P8pktZNZAN1AnECpeEoXcUKQoMjuIG4AW6gG2gJzfeSAy6GELwzdCT/Hj/k5wezLDsEQVASUcU538Vx/ALjKYoiJKKrHEbETZIktRmjv6MQgrSBmjG2MWEhxBkA9l3caw6WaAUAKxfcr0aLccJYluWiaZoKEZcu2MhWhk7CKGd9wwr1DQ+oT/gL9QWPUB+wFZ2CieiUpulRL3SzKojo4UTbtpWnKOyRX1AAeE4u3wLeOedr/bRZaveNiGvrRv0Dyr4wKql/QdV09OL3AQ6oPKa+QIX6BhVqtj4iGu2ypfWpXZ5q1l9N2gbKL+d5fkHEbff/naDKVMvixhiLHNfJpbtOornr5APyCzdyojMDaAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/mores.png
// module id = /IBO
// module chunks = 0